// import { ChooseIconComponent } from '../../../basic/icon/choose-icon/choose-icon.component';
import { Component, Input } from '@angular/core';
import { VhEventMediator, VhQueryAutoWeb } from 'vhautowebdb';
import { HttpClient } from '@angular/common/http';
import { forkJoin } from 'rxjs';
import { FunctionService} from 'vhobjects-service/src/services';
import { isPlatformBrowser } from '@angular/common';
import { PLATFORM_ID, Inject, Injectable } from '@angular/core';


@Component({
  selector: 'atw-menu-category-config',
  templateUrl: './menu-category-config.component.html',
  styleUrls: ['./menu-category-config.component.scss']
})
export class AtwMenuCategoryConfig {
  @Input() objectChoosing: any; // lấy giá trị data trả vể từ page
  @Input() device: any
  @Input() class: any; // là dữ liệu desktop_class hoặc mobile_portrait_class từ database
  @Input() config: any;@Input() type: any; // là dữ liệu desktop_config hoặc mobile_portrait_config từ database
  @Input() staticdata: any; // là dữ liệu staticdata từ database

  currentViewAll: any = {}; // biến xác định mở rộng tất cả hay theo thuộc tính
  isViewAll: boolean = false; // biến flag để hiện thị phần mở rộng cấu hình

  styles_field = [
    {
      title: 'dieu_chinh_noi_dung',
      index: 1,
    },
    {
      title: 'dieu_chinh_vien_danh_muc_cha',
      index: 2,
    },
    {
      title: 'dieu_chinh_vien_danh_muc_con',
      index: 3,
    },
    {
      title: 'nang_cao',
      index: 4,
    },
  ];

  public bootstrapIconArrows: any = [
    {
      expand_icon: 'bi bi-caret-left',
      collapse_icon: 'bi bi-caret-down',
    },
    {
      expand_icon: 'bi bi-caret-down',
      collapse_icon: 'bi bi-caret-left',
    },
    {
      expand_icon: 'bi bi-caret-left-fill',
      collapse_icon: 'bi bi-caret-down-fill',
    },
    {
      expand_icon: 'bi bi-caret-down-fill',
      collapse_icon: 'bi bi-caret-left-fill',
    },
    {
      expand_icon: 'bi bi-caret-down-square',
      collapse_icon: 'bi bi-caret-left-square',
    },
    {
      expand_icon: 'bi bi-caret-left-square',
      collapse_icon: 'bi bi-caret-down-square',
    },
    {
      expand_icon: 'bi bi-plus-circle',
      collapse_icon: 'bi bi-dash-circle',
    },
    {
      expand_icon: 'bi bi-chevron-down',
      collapse_icon: 'bi bi-chevron-up',
    },
  ];

  fonts = [];


  constructor(
    private vhQueryAutoWeb: VhQueryAutoWeb,
    private http: HttpClient,
    public vhEventMediator: VhEventMediator,
    public functionService: FunctionService,
    @Inject(PLATFORM_ID) private platformId: Object,
  ) { }


  ngOnInit() {
    if (isPlatformBrowser(this.platformId)) {
      // phần này get dữ liệu json
      forkJoin([
        this.http.get('assets/fonts/fonts.json')
      ]).subscribe(([fonts]: any) => {
        this.fonts = fonts;
      });    // Nếu chưa có config thì khởi tạo config do mới thêm config này
      if (!this.config['-webkit-scrollbar']) {
        this.config['-webkit-scrollbar'] = {
          "width": "10px",
          "background-color": "#e7e7e7",
          "thumb-background-color": "#666666",
          "border-radius": "8px"
        };
      }
    }
  }


  /**
   * Khi thay đổi Bộ icon của Tiêu đề menu cha 
   * @param icon
   */
  onChangeIcons(icon: any) {
    this.config.expand_icon = icon.expand_icon
    this.config.collapse_icon = icon.collapse_icon
    this.updateConfig();
  }


  /**
   * hàm này nhận sk thay đổi width height từ component app-width-height-config truyền về
   * @param event width hieght của element sau khi thay đổi
   */
  changeWidthHeight(event) {
    if (event.width) this.class['menu__content']['width'] = event.width + 'px';
    if (event.height) this.class['menu__content']['height'] = event.height + 'px';
    this.vhEventMediator.notifyOnConfigChanged({ status: 'update-object-selected-ruler', code: this.objectChoosing._id });
    this.updateClass();
  }


  /* ------------------------------------------------------ CÁC HÀM XỬ LÝ MENU CONFIG ----------------------------------------------------- */

  // xử lý chỉ mở được 1 menu 1 lần
  openMap: { [name: string]: boolean } = {
    menu1: true,
    menu2: false,
    menu3: false,
    menu4: false,
    menu5: false,
    menu6: false,
    menu7: false,
    menu8: false,
    menu9: false,
    menu10: false,
    menu11: false,
  };

  openHandler(value: string): void {
    for (const key in this.openMap) {
      if (key !== value) {
        this.openMap[key] = false;
      }
    }
  }

  /**
   * Hàm này dùng để mở rộng phần cấu hình.
   * @param field_text : trả về phần tử được chọn của mảng style_field
   */
  openViewAll(field_text) {
    this.currentViewAll = field_text;
    this.isViewAll = !this.isViewAll;
  }


  /* ---------------------------------------------------- CÁC HÀM UPDAQTE LÊN DATABASE ---------------------------------------------------- */

  /**
   * Hàm update object vào database.
   */
  updateObject() {
    this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { [this.device + '_class']: this.class, [this.device + '_config']: this.config, staticdata: this.staticdata })
      .then((bool: any) => {

      })
  }

  /**
   * Cập nhật staticdata vào database.
   */
  updateStaticData() {
    this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { staticdata: this.staticdata })
      .then((bool) => {

      });
  }

  /**
   * Hàm update config vào database.
   */
  updateConfig() {
    this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { [this.device + '_config']: this.config })
      .then((bool: any) => {

      })
  }

  /**
   * Hàm update class vào database.
   */
  updateClass() {
    this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { [this.device + '_class']: this.class })
      .then((bool: any) => {

      })
  }

}
